import React, { Component } from 'react';
import { WALK_THROUGH_BEACONS_LOCAL_STORAGE_ID, WALK_THROUGH_AUTO_START_LOCAL_STORAGE_ID, ON_BOARDING_DIALOG_NAME, ON_BOARDING_DIALOG_WITH_VIDEO_NAME } from 'crazyEditor/core/constants/editorConstants';
import EditorWalkThrough, {BEACONS} from './EditorWalkThrough';
import connectWithRouter from 'shared/components/redux/connectWithRouter';

const classes = require('crazyEditor/components/EditorLeftBar/DesktopEditorLeftBar.scss');

@connectWithRouter(
  (state) => ({
    walkThroughKey: state.editor.walkThroughKey,
    onBoardingDialogOpen: state.routing.location.query.openDialog === ON_BOARDING_DIALOG_NAME,
    onBoardingDialogWithVideoOpen: state.routing.location.query.openDialog === ON_BOARDING_DIALOG_WITH_VIDEO_NAME,
    generation: state.user.generation,
  })
)
export default class EditorWalkThroughWrapper extends Component {

  constructor(props) {
    super(props);
    this.state = {
      startWalkThrough: false,
      animationDone: false,
    };
  }

  componentDidMount() {
    this.detectAnimationEnd();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.walkThroughKey !== nextProps.walkThroughKey) {
      localStorage.removeItem(WALK_THROUGH_BEACONS_LOCAL_STORAGE_ID);
      this.beaconsToShow = null;
      this.setState({startWalkThrough: true});
    }
  }

  detectAnimationEnd() {
    this.animatedElement = document.querySelector(`.${classes.enterFromLeft}`);
    if (this.animatedElement) {
      this.animatedElement.addEventListener('animationend', this.handleAnimationEnd);
    }
    window.setTimeout(this.handleAnimationEnd, 800);
  }

  handleAnimationEnd = () => {
    this.setState({animationDone: true});
    if (this.animatedElement) {
      this.animatedElement.removeEventListener('animationend', this.handleAnimationEnd);
    }
  };

  render() {
    const {walkThroughKey, onBoardingDialogOpen, onBoardingDialogWithVideoOpen} = this.props;
    const {startWalkThrough, animationDone} = this.state;
    if (!animationDone || !startWalkThrough || onBoardingDialogOpen || onBoardingDialogWithVideoOpen) {
      return null;
    }

    return (
      <EditorWalkThrough key={walkThroughKey} beaconsToShow={this.beaconsToShow}/>
    );
  }
}
